export var WorkspaceStatus;
(function (WorkspaceStatus) {
    WorkspaceStatus["DRAFT"] = "draft";
    WorkspaceStatus["ACTIVE"] = "active";
})(WorkspaceStatus || (WorkspaceStatus = {}));
//# sourceMappingURL=workspace-status.enum.js.map